import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LoadingOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { CustomIcon } from 'datastake-daf/dist/components';
import { NotificationsStyle } from './style';
import { useNotificationsContext } from "./context";
import { Notification } from "./components/Notification";
import { ACTIVE_FORM_KEY } from "../Forms/settings/config";
import NotificationHistory from "./components/NotificationHistory";
import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";
import { useApp } from "../../helpers/user";

export default function Notifications({
  mod = 'pme',
  toggle = () => { },
}) {
  const { t } = useTranslation();
  const goTo = useNavigate();
  const [historyVisible, setHistoryVisible] = useState(false);
  const { loading, _notifications, _fetch, total, clearAll } = useNotificationsContext();

  const items = [
    {
      key: "details",
      icon: <CustomIcon name="CheckDone" width={13} height={13} />,
      disabled: !total,
      onClick: () => {
        clearAll();
        toggle();
      },
      label: t('Clear All'),
    },
    {
      key: "publish",
      icon: <CustomIcon name="NotificationText" width={13} height={13} />,
      onClick: () => {
        toggle();
        setHistoryVisible(true);
      },
      label: t('View All'),
    },
    {
      key: "dashboard",
      icon: <CustomIcon name="Settings" width={13} height={13} />,
      onClick: () => {
        toggle();
        goTo(`/app/${mod}/view/settings?${ACTIVE_FORM_KEY}=notifications`);
      },
      label: t('Settings'),
    },
  ]
  const app = useApp();

  return (
    <NotificationsStyle className={app}>
      <div className="notis-title">
        <h3>{t('Notification')}</h3>
        <Dropdown
          menu={{ items }}
          trigger="click"
          rootClassName={formatClassname(['dark-menu', app])}
        >
          <div className="cursor-pointer">
            <CustomIcon name="MoreCustom" width={3} height={13} />
          </div>
        </Dropdown>
      </div>
      <div
        className="notis-list"
        onScroll={(e) => {
          const _t = e.target;
          const canFetch = (_t.scrollTop + _t.clientHeight) >= _t.scrollHeight - 200;

          if (canFetch) {
            _fetch();
          }
        }}
      >
        {!loading && !total ? (
          <div className="no-notis">
            {t('No new notifications')}
          </div>
        ) : null}
        {_notifications.map((n, i) => (
          <Notification
            toggle={toggle}
            key={`notifications-${i + 1}`}
            n={n}
          />
        ))}
        {loading && (
          <div className="loading-cont">
            <LoadingOutlined />
          </div>
        )}
      </div>
      <NotificationHistory visible={historyVisible} setHistoryVisible={setHistoryVisible} />
    </NotificationsStyle>
  );
}
